import { render } from "./two-factor-verify.vue?vue&type=template&id=0d23f99a"
import script from "./two-factor-verify.vue?vue&type=script&lang=js"
export * from "./two-factor-verify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__